import styled from 'styled-components';
import { H2 } from '@increasecard/typed-components';

export default styled(H2)`
  margin: 24px 0 8px;
  font-size: 32px;
`;
